(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('HeadendManagePricing', HeadendManagePricing);

    HeadendManagePricing.$inject = ['$resource'];

    function HeadendManagePricing ($resource) {
        var resourceUrl =  'api/headend-manage-pricings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
